var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#067BC2",
    fillRule: "evenodd",
    d: "M10.301 9l6.989 6.988a1.002 1.002 0 0 1-.002 1.422l.122-.122a1 1 0 0 1-1.423.002L9 10.3 2.012 17.29a1.002 1.002 0 0 1-1.422-.002l.122.122a1 1 0 0 1-.002-1.422L7.698 9 .71 2.012A1.002 1.002 0 0 1 .712.59L.59.712A1 1 0 0 1 2.012.71L9 7.7 15.987.71a1.003 1.003 0 0 1 1.423.002L17.288.59a1 1 0 0 1 .002 1.422L10.3 9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCross);
export default __webpack_public_path__ + "static/media/icon_cross.443342dc54c0414cdc71f84599c2fac4.svg";
export { ForwardRef as ReactComponent };